import React from 'react';
import { motion } from 'framer-motion';
import { Shield, Lock, FileCheck, Users, Activity, HeartPulse, Award, ArrowRight } from 'lucide-react';
import { GlassCard } from './GlassCard';
import { SectionHeading } from './SectionHeading';
import { cn } from '../utils/cn';
const specializations = [{
  title: 'Governance',
  icon: Shield,
  color: 'bg-blue-500'
}, {
  title: 'Risk Management',
  icon: Activity,
  color: 'bg-accent-cyan'
}, {
  title: 'Compliance',
  icon: FileCheck,
  color: 'bg-status-success'
}, {
  title: 'Cybersecurity',
  icon: Lock,
  color: 'bg-primary-blue'
}, {
  title: 'Healthcare Security',
  icon: HeartPulse,
  color: 'bg-status-danger'
}, {
  title: 'Executive Protection',
  icon: Users,
  color: 'bg-status-warning'
}];
export function AboutSection() {
  return <section className="py-24 relative" data-id="element-1">
      <div className="container mx-auto px-6" data-id="element-2">
        <div className="grid lg:grid-cols-2 gap-16 items-center" data-id="element-3">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="relative" data-id="element-4">
            <div className="relative rounded-3xl overflow-hidden border border-white/10 shadow-2xl" data-id="element-5">
              <img src="https://www.cyberreadysecurity.info/wp-content/themes/cyberreadyip212/images/main-img.png" alt="Cyber Ready Security Training" className="w-full h-auto" data-id="element-6" />
              <div className="absolute inset-0 bg-gradient-to-t from-background/80 via-transparent to-transparent" data-id="element-7" />
            </div>

            {/* Floating Achievement Card */}
            <motion.div animate={{
            y: [0, -15, 0]
          }} transition={{
            duration: 5,
            repeat: Infinity,
            ease: 'easeInOut'
          }} className="absolute -bottom-8 -right-8 max-w-[240px]" data-id="element-8">
              <GlassCard className="p-6 border-white/20" data-id="element-9">
                <div className="flex items-center gap-4 mb-3" data-id="element-10">
                  <div className="w-10 h-10 rounded-full bg-primary-blue flex items-center justify-center text-white" data-id="element-11">
                    <Award size={20} data-id="element-12" />
                  </div>
                  <div data-id="element-13">
                    <div className="text-xs text-white/40 uppercase font-bold" data-id="element-14">
                      Accredited
                    </div>
                    <div className="text-sm font-bold text-white" data-id="element-15">
                      Global Standards
                    </div>
                  </div>
                </div>
                <p className="text-[11px] text-white/60 leading-relaxed" data-id="element-16">
                  Our curriculum is aligned with NIST, ISO 27001, and SOC2
                  frameworks.
                </p>
              </GlassCard>
            </motion.div>
          </motion.div>

          <div className="space-y-8" data-id="element-17">
            <SectionHeading title="Elite Training for the Next Generation of Security Leaders" subtitle="Cyber Ready Security (CRS) is North America's premier cybersecurity academy, dedicated to bridging the talent gap with immersive, industry-aligned training." align="left" data-id="element-18" />

            <div className="grid grid-cols-2 gap-4" data-id="element-19">
              {specializations.map((spec, i) => <motion.div key={spec.title} initial={{
              opacity: 0,
              y: 10
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: i * 0.1
            }} data-id="element-20">
                  <div className="flex items-center gap-3 p-4 rounded-2xl bg-white/5 border border-white/5 hover:border-white/10 transition-colors group" data-id="element-21">
                    <div className={cn('w-10 h-10 rounded-lg flex items-center justify-center text-white group-hover:scale-110 transition-transform shadow-lg', spec.color)} data-id="element-22">
                      <spec.icon size={20} data-id="element-23" />
                    </div>
                    <span className="text-sm font-semibold text-white/80" data-id="element-24">
                      {spec.title}
                    </span>
                  </div>
                </motion.div>)}
            </div>

            <div className="pt-6" data-id="element-25">
              <button className="flex items-center gap-2 text-primary-blue font-bold hover:gap-4 transition-all group" data-id="element-26">
                Learn more about our mission{' '}
                <ArrowRight size={20} className="group-hover:translate-x-1" data-id="element-27" />
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>;
}